import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Divider, DynamicSvg, isValidObject, LILAC_400, LILAC_500, Notifier, Typography, WHITE } from '@airtel/air-design-system';
import { Fragment } from 'react';
import { FlatList, Pressable, Modal as RNModal, SafeAreaView, View } from 'react-native';
import { withBoundaries } from '../../../../hoc';
import { ButtonWidget } from '../../../button-widget';
import { getSingleFilterCount, getTotalFilterCount } from '../../FilterUtils';
import { FilterItem } from '../filter-item';
import { getFilterSectionMobileStyles } from './FilterMobileStyles';
var FilterMobileComponent = props => {
  var filterData = props.filterData,
    selectedFilter = props.selectedFilter,
    type = props.type,
    mobileHeaderProps = props.mobileHeaderProps,
    onClear = props.onClear,
    onSelectedFilter = props.onSelectedFilter,
    onSelectedFilterCategory = props.onSelectedFilterCategory,
    onApplyFilter = props.onApplyFilter,
    onCloseFilter = props.onCloseFilter,
    _props$isInsideModal = props.isInsideModal,
    isInsideModal = _props$isInsideModal === void 0 ? false : _props$isInsideModal;
  var filterSectionMobileStyles = getFilterSectionMobileStyles(props);
  var totalFilterAppliedCountLabel = getTotalFilterCount(filterData) + " Filter applied";
  var onClose = () => {
    onCloseFilter === null || onCloseFilter === void 0 ? void 0 : onCloseFilter();
  };
  var renderBorder = function renderBorder(vertical, backgroundColor) {
    if (vertical === void 0) {
      vertical = false;
    }
    if (backgroundColor === void 0) {
      backgroundColor = LILAC_400;
    }
    return _jsx(View, {
      style: [vertical ? filterSectionMobileStyles.borderVertical : filterSectionMobileStyles.borderHorizontal, {
        backgroundColor
      }]
    });
  };
  var renderFilterCategory = _ref => {
    var item = _ref.item,
      index = _ref.index;
    var count = getSingleFilterCount(item);
    var filterCategoryIcon = item.filterCategoryIcon,
      filterCategoryIconProps = item.filterCategoryIconProps;
    return _jsxs(_Fragment, {
      children: [_jsxs(Pressable, Object.assign({
        style: [filterSectionMobileStyles.row, filterSectionMobileStyles.center, filterSectionMobileStyles.categoryContainer, (item === null || item === void 0 ? void 0 : item.checked) && filterSectionMobileStyles.categorySelectedContainer],
        onPress: () => onSelectedFilterCategory(item, index)
      }, {
        children: [_jsxs(View, Object.assign({
          style: filterSectionMobileStyles.center
        }, {
          children: [!!filterCategoryIcon && _jsx(DynamicSvg, Object.assign({
            width: 16,
            height: 16,
            iconName: filterCategoryIcon
          }, filterCategoryIconProps)), _jsx(Typography, {
            text: item === null || item === void 0 ? void 0 : item.filterCategory,
            type: (item === null || item === void 0 ? void 0 : item.checked) ? 'body-para-sm-bold' : 'body-para-sm',
            style: filterSectionMobileStyles.categoryContainerText
          })]
        })), !!count && _jsx(View, Object.assign({
          style: [filterSectionMobileStyles.center, filterSectionMobileStyles.notifierContainer]
        }, {
          children: _jsx(Notifier, {
            number: count
          })
        }))]
      })), index < filterData.length - 1 && _jsxs(_Fragment, {
        children: [renderBorder(false, LILAC_400), renderBorder(false, WHITE)]
      })]
    });
  };
  var renderFilterItemValue = _ref2 => {
    var item = _ref2.item,
      index = _ref2.index;
    return _jsx(FilterItem, {
      item: item,
      index: index,
      type: type,
      onFilterItemPress: onSelectedFilter,
      style: filterSectionMobileStyles.itemContainer
    });
  };
  var Component = isInsideModal ? Fragment : RNModal;
  var componentProps = isInsideModal ? {} : {
    transparent: true
  };
  return _jsx(Component, Object.assign({}, componentProps, {
    children: _jsxs(SafeAreaView, Object.assign({
      style: [filterSectionMobileStyles.container]
    }, {
      children: [_jsxs(View, Object.assign({
        style: [filterSectionMobileStyles.showAsFullPage]
      }, {
        children: [!!isValidObject(mobileHeaderProps) && _jsx(View, Object.assign({
          style: [filterSectionMobileStyles.topHeader, mobileHeaderProps === null || mobileHeaderProps === void 0 ? void 0 : mobileHeaderProps.style]
        }, {
          children: _jsx(Typography, {
            text: (mobileHeaderProps === null || mobileHeaderProps === void 0 ? void 0 : mobileHeaderProps.text) || 'Filter',
            noTextTransform: true,
            type: (mobileHeaderProps === null || mobileHeaderProps === void 0 ? void 0 : mobileHeaderProps.type) || 'body-single-line-lg-bold'
          })
        })), _jsxs(View, Object.assign({
          style: filterSectionMobileStyles.row
        }, {
          children: [_jsx(Typography, {
            text: totalFilterAppliedCountLabel,
            type: "title-single-line-lg"
          }), _jsx(Button, {
            buttonType: "tertiary",
            title: "Clear All",
            size: "md",
            onPress: onClear
          })]
        })), _jsxs(View, Object.assign({
          style: [filterSectionMobileStyles.container, filterSectionMobileStyles.content]
        }, {
          children: [_jsx(FlatList, {
            data: filterData,
            renderItem: renderFilterCategory,
            keyExtractor: item => item.filterCategory,
            style: filterSectionMobileStyles.leftPanel
          }), renderBorder(true, LILAC_400), renderBorder(true, WHITE), _jsx(FlatList, {
            testID: "rightPanel",
            data: selectedFilter !== null && selectedFilter !== void 0 ? selectedFilter : [],
            renderItem: renderFilterItemValue,
            keyExtractor: item => item === null || item === void 0 ? void 0 : item.name,
            style: filterSectionMobileStyles.rightPanel
          })]
        }))]
      })), _jsxs(View, Object.assign({
        style: [filterSectionMobileStyles.footerContainer]
      }, {
        children: [_jsx(Divider, {
          height: 1,
          color: LILAC_500,
          style: filterSectionMobileStyles.dividerStyle
        }), _jsx(ButtonWidget, {
          leftCta: {
            title: 'CLOSE',
            buttonType: 'secondary',
            isUpperCase: true,
            onPress: onClose
          },
          rightCta: {
            title: 'APPLY FILTER',
            buttonType: 'primary',
            isUpperCase: true,
            onPress: onApplyFilter
          },
          direction: "row",
          style: filterSectionMobileStyles.footerBtnContainer
        })]
      }))]
    }))
  }));
};
export var FilterMobile = withBoundaries(FilterMobileComponent);